import moment from 'moment'
import React, { FC } from 'react'

//* utils
import { OPTIONS } from '../../../../../constants/dateOptions'
import ImgUtil from '../../../../../utils/img.utils'
import formatInlineCode from '../../../../../utils/shortTextFormatting'

//* components
import Bio from '../../../../global/bio'
import Breadcrumbs from '../../../../global/breadcrumbs'
import Typography from '../../../../global/typography'
import WrapperImage from '../../../../global/wrapperImage'

type Props = {
  blogData: any
}

export const TopSection: FC<Props> = ({ blogData }) => {
  let formattedDate = ''
  if (blogData.createdAt) {
    const date = new Date(blogData.createdAt)
    formattedDate = moment(date).utc().format('MMMM D, YYYY')
    formattedDate = new Date(formattedDate).toLocaleDateString(blogData.node_locale, OPTIONS)
  }

  return (
    <>
      <div className="BlogPost__Breadcrumbs-Container">
        <Breadcrumbs
          className="BlogPost__Breadcrumbs"
          backgroundTheme="light"
          currentPathname={blogData.blogPostPath}
          pageName={blogData.pageName}
          isBlogBreadcrumb={true}
          locale={blogData.node_locale}
          isSecondaryBlog={blogData.isSecondaryBlog}
        />
      </div>

      <Typography type="header1">{formatInlineCode(blogData.name)}</Typography>

      <div className="BlogPost__Byline">
        <Bio
          data={blogData.author}
          type="bioByline"
          locale={blogData.node_locale}
          isSecondaryBlog={blogData.isSecondaryBlog}
          useCase={blogData.category.useCase}
        />

        <span className="BlogPost__Byline-Dot">•</span>
        <span className="BlogPost__Byline-Date">{formattedDate}</span>
      </div>

      <div className="BlogPost__Image-Container">
        {blogData.mainImage.url && (
          <WrapperImage
            className="BlogPost__Image"
            loading="lazy"
            alt={blogData.mainImage.altText}
            src={ImgUtil.getResizedImageUrl(blogData.mainImage.url, 'width=1200')}
            width={1200}
            height={600}
            threshold={650}
          />
        )}
      </div>
    </>
  )
}
